import {NgModule} from '@angular/core';
import {ChatterComponent} from './chatter.component';
import {MaterialModule} from '../../app.material.module';
import {CommonModule} from '@angular/common';
import {ChatterMessageComponent} from './message/chatter-message.component';
import {ChatterFreeformComponent} from './input/freeform/chatter-freeform.component';
import {ChatterProvidedSetComponent} from './input/provided-set/chatter-provided-set.component';
import {ChatterModalComponent} from './input/modal/chatter-modal.component';
import {InterestSelectorModule} from '../interest/interest-selector/interest-selector.module';
import {AccordionModule} from '../accordion/accordion.module';
import {DonutBarModule} from '../donut-bar/donut-bar.module';
import {ChatterKassabonComponent} from './chatter-kassabon/chatter-kassabon.component';
import {ChatterKassabonModalComponent} from './chatter-kassabon-modal/chatter-kassabon-modal.component';
import {ContentModule} from '../../services/content/content.module';
import {EntitySelectorComponent} from './input/entity-selector/entity-selector.component';
import {InputModule} from '../input/input.module';
import {ReactiveFormsModule} from '@angular/forms';

@NgModule({
    declarations: [
        ChatterComponent,
        ChatterMessageComponent,
        ChatterFreeformComponent,
        ChatterProvidedSetComponent,
        ChatterModalComponent,
        ChatterKassabonComponent,
        ChatterKassabonModalComponent,
        EntitySelectorComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        InterestSelectorModule,
        AccordionModule,
        DonutBarModule,
        ContentModule,
        InputModule,
        ReactiveFormsModule
    ],
    exports: [
        ChatterComponent,
        ChatterMessageComponent,
        ChatterFreeformComponent,
        ChatterProvidedSetComponent,
        ChatterModalComponent,
        ChatterKassabonComponent,
        ChatterKassabonModalComponent,
        EntitySelectorComponent
    ]
})
export class ChatterModule {}
